import { createContext, useState } from "react";

const GlobalContext = createContext<any>({});


export function GlobalProvider({ children }: { children: any }) {
    const [staffName, setStaffName] = useState("");

    return (
        <GlobalContext.Provider value={{ staffName, setStaffName }}>
            {children}
        </GlobalContext.Provider>
    )

}

export default GlobalContext;